var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "SavePanelView", class: [_vm.saving && "edit"] },
    [
      _c(
        "button",
        {
          staticClass: "SavePanelViewSave",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("save")
            },
          },
        },
        [_vm._v("\n\t\tSave changes\n\t")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }